import { IEmailEntity, IPhoneNumberEntity } from '../interfaces/contact.interfaces';

export const getEmptyEmailEntity = (): IEmailEntity => {
    return {
        id: undefined,
        emailAddress: '',
        userId: +sessionStorage.getItem('userId'),
        isConfirmed: undefined,
    };
};

export const getEmptyMobileEntity = (): IPhoneNumberEntity => {
    return {
        id: undefined,
        countryCodeId: undefined,
        phoneNumber: '',
        userId: +sessionStorage.getItem('userId'),
        isConfirmed: undefined,
    };
};
